import type { CommunicationTemplateType } from "@bbj-types/communication/enum";
import { Autocomplete, Box, Stack, TextField, type Theme, Typography, useMediaQuery } from "@mui/material";
import { useMemo } from "react";
import { type Control, Controller, type UseFormSetValue } from "react-hook-form";
import type { IEmailFormTemplate } from ".";
import type { TEmailForm } from "./resolver";

interface IWorkshopTemplateListFormProps {
  control: Control<TEmailForm, void>;
  setValue: UseFormSetValue<TEmailForm>;
  templates: (IEmailFormTemplate & { type: CommunicationTemplateType.EMAIL })[];
}

export const MenuTemplate = ({ control, templates, setValue }: IWorkshopTemplateListFormProps) => {
  const isTablet = useMediaQuery((theme: Theme) => theme.breakpoints.up("tablet"));

  const parsedTemplates = useMemo(() => {
    const result = new Map<string, Omit<IEmailFormTemplate, "_id">>();

    return templates.reduce((acc, curr) => {
      const { _id, ...rest } = curr;
      acc.set(_id, rest);
      return acc;
    }, result);
  }, [templates]);

  if (templates.length < 1) {
    return null;
  }

  return (
    <Stack
      direction={isTablet ? "row" : "column"}
      sx={{
        gap: 1,
        alignItems: isTablet ? "center" : "start",
      }}
    >
      <Typography>Modèle :</Typography>
      <Controller
        control={control}
        name="templateType"
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Autocomplete
            value={templates.find((t) => t.name === value) ?? null}
            options={templates}
            getOptionLabel={(template) => template.name}
            isOptionEqualToValue={(option, value) => option._id === value._id}
            onChange={(_, value) => {
              if (value) {
                onChange(value.name);
                setValue("subject", parsedTemplates.get(value?._id ?? "")?.subject ?? "");
                setValue("content", parsedTemplates.get(value?._id ?? "")?.content ?? "");
              } else {
                onChange("");
                setValue("subject", "");
                setValue("content", "");
              }
            }}
            size="small"
            sx={isTablet ? { minWidth: "360px" } : undefined}
            fullWidth={!isTablet}
            renderInput={(props) => (
              <TextField {...props} error={!!error} helperText={error?.message} label={<Box>Modèle</Box>} />
            )}
          />
        )}
      />
    </Stack>
  );
};
